import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  }, {
    path: '/residence',
    name: 'residence',
    component: () => import('../views/Residence/Residence.vue'),

  },
  {
    path: '/residence/:id',
    name: 'residence',
    component: () => import('../views/Residence/ResidenceSingle.vue')
  }
  ,
  {
    path: '/tour',
    name: 'tour',
    component: () => import('../views/Tour/Tour.vue')
  }
  ,
  {
    path: '/tour/:id',
    name: 'tour',
    component: () => import('../views/Tour/TourSingle.vue')
  }
  ,
  {
    path: '/restaurant',
    name: 'restaurant',
    component: () => import('../views/Restaurant/Restaurant.vue')
  },
  {
    path: '/restaurant/:id',
    name: 'restaurant-single',
    component: () => import('../views/Restaurant/RestaurantSingle.vue')
  },
  {
    path: '/corridor',
    name: 'corridor',
    component: () => import('../views/Corridor/Corridor.vue')
  },
  {
    path: '/maps',
    name: 'corridor2',
    component: () => import('../views/Corridor/Corridor2.vue')
  },
  {
    path: '/profile/dashboard',
    name: 'dashboard',
    component: () => import('../views/Profile/Dashboard.vue')
  }
  ,
  {
    path: '/profile/messages',
    name: 'messages',
    component: () => import('../views/Profile/Messages.vue')
  },
  {
    path: '/profile/wallet',
    name: 'wallet',
    component: () => import('../views/Profile/Wallet.vue')
  },
  {
    path: '/profile/transaction',
    name: 'transaction',
    component: () => import('../views/Profile/Transaction.vue')
  },
  {
    path: '/profile/restaurant-history',
    name: 'restaurant-his',
    component: () => import('../views/Profile/RestaurantHis.vue')
  }
  ,
  {
    path: '/profile/tur-hotel',
    name: 'tur-hotel',
    component: () => import('../views/Profile/TurHotel.vue')
  }
  ,
  {
    path: '/profile/favorite',
    name: 'favorite',
    component: () => import('../views/Profile/Favorite.vue')
  },
  {
    path: '/profile/gifts',
    name: 'gifts',
    component: () => import('../views/Profile/Gifts.vue')
  },
  {
    path: '/profile/invite',
    name: 'invite',
    component: () => import('../views/Profile/Invite.vue')
  },
  {
    path: '/profile/account',
    name: 'account',
    component: () => import('../views/Profile/Account.vue')
  }
  ,
  {
    path: '/customer-club',
    name: 'customer-club',
    component: () => import('../views/CustomerClub/index.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/Blog/Blog.vue')
  },
  {
    path: '/blog/:id?',
    name: 'single-blog',
    component: () => import('../views/Blog/BlogSingle.vue')
  },
  // {
  //   path: '/province/:id?',
  //   name: 'single-province',
  //   component: () => import('../views/province/Province.vue')
  // },

  //***hormozi
  {
    path: '/Map',
    name: 'Map',
    component: () => import('../views/Map.vue')
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: () => import('../views/Residence/reservation.vue'),
  },
  {
    path: '/residenceConfirm',
    name: 'residenceConfirm',
    component: () => import('../views/Residence/residenceConfirm.vue'),
  },
  {
    path: '/residenceSuccess',
    name: 'residenceSuccess',
    component: () => import('../views/Residence/residenceSuccess.vue'),
  },
  {
    path: '/TourReserve',
    name: 'TourReserve',
    component: () => import('../views/Tour/TourReserve.vue'),
  },
  {
    path: '/TourComplete',
    name: 'TourComplete',
    component: () => import('../views/Tour/TourComplete.vue'),
  },
  {
    path: '/TourReserved',
    name: 'TourReserved',
    component: () => import('../views/Tour/TourReserved.vue'),
  },
  {
    path: '/TourPassengers',
    name: 'TourPassengers',
    component: () => import('../views/Tour/TourPassenger.vue'),
  },
  {
    path: '/ProvienceSingle/:id',
    name: 'ProvienceSingle',
    component: () => import('../views/province/ProvienceSingle.vue'),
  },
  {
    path: '/Ticket',
    name: 'Ticket',
    component: () => import('../views/Ticket/Ticket.vue'),
  },
  {
    path: '/TicketReserve',
    name: 'TicketReserve',
    component: () => import('../views/Ticket/TicketReserve.vue'),
  },
  {
    path: '/TicketConfirm',
    name: 'TicketConfirm',
    component: () => import('../views/Ticket/TicketConfirm.vue'),
  },
  {
    path: '/TourismService',
    name: 'TourismService',
    component: () => import('../views/TourismService/TourismService')
  },
  {
    path: '/CarService',
    name: 'CarService',
    component: () => import('../views/TourismService/CarService')
  },
  {
    path: '/OnlineTeach',
    name: 'OnlineTeach',
    component: () => import('../views/TourismService/OnlineTeach')
  },
  {
    path: '/service-providers',
    name: 'service-providers',
    component: () => import('../views/TourismService/ServiceProviders')
  },
  {
    path: '/ExportLisence',
    name: 'ExportLisence',
    component: () => import('../views/TourismService/ExportLisence')
  },
  {
    path: '/NotElectronic',
    name: 'NotElectronic',
    component: () => import('../views/TourismService/NotElectronic')
  },
  {
    path: '/Electronic',
    name: 'Electronic',
    component: () => import('../views/TourismService/Electronic')
  },
  {
    path: '/PublicService',
    name: 'PublicService',
    component: () => import('../views/TourismService/PublicService')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/reportTrip/ReportTrip')
  },
    {
    path: '/iranbin',
    name: 'iranbin',
    component: () => import('../views/IranBin/IranBin.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  return next();
})
export default router
